const dashboardNL = {
    "view": {
        "label": {
            "allTimeSales": "Verkopen van alle tijden",
            "totalToBePaid": "Totaal te betalen",
            "promoCoins": "Promo Munten",
            "promoDownloadCount": "Promo Download Aantal",
            "promoFeedbackCount": "Promo Feedback Aantal",
            "totalDownloads": "Totaal Downloads",
            "totalFeedbacks": "Totaal Feedbacks"
        },
        "options": {
            "earnings": {
                "allTime": "Verdiensten van alle tijden",
                "last12Months": "Laatste 12 maanden"
            },
            "months": {
                "jan": "Jan",
                "feb": "Feb",
                "mar": "Mrt",
                "apr": "Apr",
                "may": "Mei",
                "jun": "Jun",
                "jul": "Jul",
                "aug": "Aug",
                "sep": "Sep",
                "oct": "Okt",
                "nov": "Nov",
                "dec": "Dec"
            }
        },
        "message": {
            "userWelcomeTitle": "Hey {{firstName}}, welkom terug bij Music Link Platform.",
            "ownedAndManaged": "Je account wordt beheerd door <1>{{ parent_company }}</1>, bezoek onze <3>Help Pagina</3> voor meer informatie.",
            "completeInformation": "Je hebt je informatie nog niet ingediend, gelieve <1><strong>Je Informatie Aan te Vullen</strong></1> om verder te gaan!",
            "notSubscribed": "Je bent niet geabonneerd op een plan. Abonneer je nu om het volledige potentieel van het Music Link platform te ontgrendelen!",
            "accountBlacklisted": "Je account is na een controle als zwarte lijst gemarkeerd, omdat we hebben ontdekt dat de informatie die aan je account is gekoppeld aan een van de internationale zwarte lijst gebruikers in ons systeem is gekoppeld. Daarom hebben we de distributiefunctie voor je account uitgeschakeld.",
        }
    }
};

export default dashboardNL;